import { jsx as _jsx } from "react/jsx-runtime";
import { TimePickerInput } from '@ui/primitives';
import { format } from 'date-fns';
import * as React from 'react';
export const TimePicker = /*#__PURE__*/ React.forwardRef((param, ref)=>{
    let { date, onTimeChange, className } = param;
    const defaultValue = date ? format(date, 'HH:mm:ss') : '08:30:00';
    const dateKey = date ? format(date, 'yyyy-MM-dd') : 'empty';
    const handleChange = React.useCallback((e)=>{
        const raw = e.target.value;
        if (!raw) return;
        const [h, m, s] = raw.split(':').map(Number);
        if (h == null || isNaN(h) || h < 0 || h > 23) return;
        const minutes = m !== null && m !== void 0 ? m : 0;
        const seconds = s !== null && s !== void 0 ? s : 0;
        if (minutes < 0 || minutes > 59 || seconds < 0 || seconds > 59) return;
        const base = date !== null && date !== void 0 ? date : new Date();
        const next = new Date(base.getTime());
        next.setHours(h, minutes, seconds, 0);
        onTimeChange(next);
    }, [
        date,
        onTimeChange
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: className,
        children: /*#__PURE__*/ _jsx(TimePickerInput, {
            ref: ref,
            defaultValue: defaultValue,
            onChange: handleChange,
            className: "w-full"
        }, dateKey)
    });
});
TimePicker.displayName = 'TimePicker';
